import { classNames } from "primereact/utils";
import styles from "./ProgressBar.module.scss";

interface IProgressBarProps {
  className?: string;
  progress: number; // 0-100 percentage
  animated?: boolean;
}

export const ProgressBar = ({ 
  className, 
  progress, 
  animated = true 
}: IProgressBarProps) => {
  return (
    <div className={classNames(styles.progressContainer, className)}>
      <div 
        className={classNames(styles.progressBar, {
          [styles.animated]: animated
        })}
        style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
      />
    </div>
  );
};